import {Fade, IconButton, Modal, Paper, Tooltip, Typography, Box, useMediaQuery} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {motion, AnimatePresence} from "framer-motion"; // ДЛЯ АНИМАЦИЙ
import {useEffect} from "react";

export default function ImageModal({
                                       imageSrc,
                                       setImageSrc,
                                       handleNextImage,
                                       handlePrevImage,
                                       resetCurrentImageIndex,
                                       imageSingleDescriptions = "",
                                   }) {
    const isMobile = useMediaQuery("(max-width: 600px)");
    // Функция закрытия модального окна
    const closeModal = () => {
        setImageSrc(null);
        resetCurrentImageIndex(); // Сбрасываем индекс
    };

    // Добавляем поддержку клавиатуры (Стрелки, Escape)
    useEffect(() => {
        if (!imageSrc) return;

        const handleKeyDown = (event) => {
            if (event.key === "ArrowRight") handleNextImage(); // Листать вправо
            if (event.key === "ArrowLeft") handlePrevImage();  // Листать влево
            if (event.key === "Escape") closeModal();          // Закрытие на Esc
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [imageSrc]);

    return (
        <Modal
            open={!!imageSrc}
            onClose={closeModal}
            closeAfterTransition
            className="flex abs-center"
            slotProps={{
                backdrop: {
                    sx: {backgroundColor: 'transparent'}, // 👈 убираем фон MUI
                },
            }}
        >
            <Fade in={!!imageSrc}>
                <Box
                    sx={{
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(234,228,228,0.9)", // Затемненный фон
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={closeModal} // Закрытие по клику вне изображения
                >
                    <AnimatePresence>
                        {imageSrc && (
                            <motion.div
                                initial={{scale: 0.8, opacity: 0}}
                                animate={{scale: 1, opacity: 1}}
                                exit={{scale: 0.8, opacity: 0}}
                                transition={{duration: 0.3, ease: "easeOut"}}
                                style={{
                                    position: "relative",
                                    width: isMobile ? "calc(100vw - 16px)" : "90vw",
                                    height: isMobile ? "100vh" : "90vh",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                                onClick={(e) => e.stopPropagation()} // Останавливаем всплытие
                            >
                                {/* Кнопка закрытия */}
                                <Tooltip title="Закрити">
                                    <IconButton
                                        sx={{
                                            position: "absolute",
                                            right: isMobile ? 4 : 10,
                                            top: isMobile ? 4 : 10,
                                            backgroundColor: "#fff",
                                            "&:hover": {backgroundColor: "red", color: "#fff"},
                                        }}
                                        onClick={closeModal}
                                    >
                                        <CloseIcon/>
                                    </IconButton>
                                </Tooltip>

                                {/* Кнопка влево */}
                                <IconButton
                                    sx={{
                                        position: "absolute",
                                        left: isMobile ? 4 : 20,
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        backgroundColor: "#fff",
                                        "&:hover": {backgroundColor: "#ddd"},
                                    }}
                                    onClick={handlePrevImage}
                                >
                                    <ArrowBackIosIcon/>
                                </IconButton>

                                {/* Кнопка вправо */}
                                <IconButton
                                    sx={{
                                        position: "absolute",
                                        right: isMobile ? 4 : 20,
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        backgroundColor: "#fff",
                                        "&:hover": {backgroundColor: "#ddd"},
                                    }}
                                    onClick={handleNextImage}
                                >
                                    <ArrowForwardIosIcon/>
                                </IconButton>

                                {/* Изображение */}
                                <motion.img
                                    key={imageSrc} // Чтобы изображение анимировалось при смене
                                    src={imageSrc}
                                    alt="Full size image"
                                    initial={{opacity: 0, x: 50}}
                                    animate={{opacity: 1, x: 0}}
                                    exit={{opacity: 0, x: -50}}
                                    transition={{duration: 0.3}}
                                    style={{
                                        maxWidth: isMobile ? "calc(100vw - 16px)" : "80%",
                                        maxHeight: isMobile ? "calc(100vh - 96px)" : "80%",
                                        objectFit: "contain",
                                        display: "block",
                                        borderRadius: "10px",
                                        boxShadow: "0px 0px 15px rgba(255,255,255,0.5)",
                                    }}
                                />

                                {/* Описание изображения */}
                                <Typography
                                    variant="body1"
                                    sx={{
                                        textAlign: "center",
                                        color: "#000000",
                                        fontSize: "1rem",
                                        maxWidth: isMobile ? "calc(100vw - 16px)" : "80%",
                                        marginTop: "1rem",
                                        fontWeight: 'bold'
                                    }}
                                >
                                    {imageSingleDescriptions}
                                </Typography>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </Box>
            </Fade>
        </Modal>
    );
}
